module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/pages/redirect.component.html
// module id = ../../../../../src/app/views/pages/redirect.component.html
// module chunks = main